import api from './api';

export type UserRole = 'admin' | 'receptionist' | 'dentist';

export interface UserPermission {
  id: string;
  name: string;
  email: string;
  role: UserRole;
  phone?: string | null;
  isActive: boolean;
  createdAt?: string | null;
  updatedAt?: string | null;
  permissions: string[];
}

export interface RolePermissions {
  role: UserRole;
  permissions: string[];
}

export const userService = {
  async getUsers(): Promise<UserPermission[]> {
    const response = await api.get('/users');
    return response.data;
  },

  async createUser(data: {
    name: string;
    email: string;
    password: string;
    role: UserRole;
    phone?: string;
    isActive: boolean;
  }): Promise<UserPermission> {
    const response = await api.post('/users', data);
    return response.data;
  },

  async updateUser(
    id: string,
    data: Partial<{
      name: string;
      email: string;
      role: UserRole;
      phone: string | null;
      isActive: boolean;
    }>
  ): Promise<UserPermission> {
    const response = await api.patch(`/users/${id}`, data);
    return response.data;
  },

  async resetPassword(id: string, password: string): Promise<void> {
    await api.patch(`/users/${id}/password`, { password });
  },

  async getPermissions(): Promise<RolePermissions[]> {
    const response = await api.get('/permissions');
    return response.data.roles;
  },
};
